import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import api, { MainDomain } from 'api';
import { toast } from 'react-toastify';
import { actions } from 'redux/reducers';
import './login.scss';

function Login() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    function doLogin() {
        if (!email) { toast.warning("Email cannot be empty"); return; }
        if (!password) { toast.warning("Password cannot be empty"); return; }

        setLoading(true);
        api.user.login(email, password)
        .then(data => {
            localStorage.AccessToken = data.access_token;
            setLoading(false);
            getUser();
            getClients();
            history.push("/clients");
        })
        .catch(err => {
            toast.error(err.toString());
            setLoading(false);
        })
    }

    const getUser = () => {
        api.user.get().then(data => {
            dispatch(actions.user.set(data));
        })
    }

    const getClients = () => {
        api.clients.getAll().then(data => {
            dispatch(actions.clients.set(data));
        });
    }

    useEffect(() => {
        localStorage.removeItem("AccessToken");
        dispatch(actions.user.logout());
    }, [dispatch])

    return (
        <div id="login" className="container">
            <div>
                <div className="logo-section">
                    <span className="logo-detail">Workflow</span>
                    {MainDomain}
                </div>
            </div>
            <div>
                <h2>LOGIN</h2>
                <input type="email" placeholder="Email" onChange={(e: any) => setEmail(e.target.value)} readOnly onFocus={(e) => e.target.removeAttribute("readonly")} onKeyUp={(e) => e.key === "Enter" ? doLogin() : null} />
                <input type="password" placeholder="Password" onChange={(e: any) => setPassword(e.target.value)} readOnly onFocus={(e) => e.target.removeAttribute("readonly")} onKeyUp={(e) => e.key === "Enter" ? doLogin() : null} />
                <button onClick={doLogin}>{!loading ? 'LOGIN' : <i className="fal fa-spinner fa-spin"></i>}</button>
                <Link to="/forgot-password">FORGOT PASSWORD</Link>
            </div>
        </div>
    )
}

export default Login;